var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentStore)?_c('div',{staticClass:"df-page df-page-product"},[_c('df-header-mobile'),_vm._m(0),_c('df-footer')],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"df-page-body"},[_c('div',{staticClass:"df-product-details-wrapper"},[_c('div',{staticClass:"df-page-body-header"}),_c('div',{staticClass:"df-product-details"})])])
}]

export { render, staticRenderFns }